import { isProductCacheEnabled } from 'utils';
import { useFetchProducts, useFetchProductsUsingRedis } from '../queries';
import {
  ProductsRequestParams,
  ProductsUsingRedisRequestParams,
  SortDirection,
} from 'types';
import getConfig from 'next/config';

// This function determines which product fetching strategy to use based on the cache status
export const useFetchProductStrategy = ({
  taxonslug,
  variantIds,
  skus,
  sortDirection,
}: {
  taxonslug: string;
  variantIds: string[];
  skus: string[];
  sortDirection?: SortDirection;
}) => {
  const { publicRuntimeConfig } = getConfig();
  const paramsWithoutCache: ProductsRequestParams = {
    taxonSlug: taxonslug,
    variantIds: variantIds,
    sortDirection: '',
    categoryFilters: [],
    skus: skus,
    pageSize: publicRuntimeConfig.LISTING_PAGE_SIZE,
  };

  const paramsWithCache: ProductsUsingRedisRequestParams = {
    searchCriteria: {
      taxonSlug: taxonslug,
      variantIds: variantIds.join(','),
      skus: skus.join(','),
    },
    filters: [],
    sortDirection: sortDirection,
    pageSize: publicRuntimeConfig.LISTING_PAGE_SIZE,
  };
  const fetchProductsUsingRedis = useFetchProductsUsingRedis(paramsWithCache);

  const fetchProducts = useFetchProducts(paramsWithoutCache);

  return isProductCacheEnabled() ? fetchProductsUsingRedis : fetchProducts;
};
